import React, { useEffect, useState } from "react";
import config from "../../../common/config";

const RailViewData = (props) => {
  return (
    <>
      <div
        style={{
          border: "1px solid grey",
          borderRadius: "5px",
          padding: "5px",
        }}
      >
        <div
          style={{ width: "50%", display: "inline-block", fontSize: "larger" }}
        >
          <div>
            <span className="labelrailgrid">SQDCP:</span>
            <span>{props?.data?.data?.sqdcp}</span>
          </div>
          <div>
            <span className="labelrailgrid">Tier Name:</span>
            <span>{props?.data?.data?.tiername}</span>
          </div>
          <div>
            <span className="labelrailgrid">Site Name:</span>
            <span>{props?.data?.data?.sitename}</span>
          </div>
          <div>
            <span className="labelrailgrid">Actions:</span>
            <span>{props?.data?.data?.actions}</span>
          </div>
          {/* <div>
            <span className="labelrailgrid">Notes:</span>
            <span>{props?.data?.data?.notes}</span>
          </div> */}
          <div>
            <span className="labelrailgrid">Owner Email:</span>
            <span>{props?.data?.data?.ownerEmail}</span>
          </div>
        </div>
        <div
          style={{ width: "50%", display: "inline-block", fontSize: "larger" }}
        >
          <div>
            <span className="labelrailgrid">top 3:</span>
            <span>{props?.data?.data?.top3}</span>
          </div>
          { config.DEV_DISPLAY_OPTIONS && <div>
            <span className="labelrailgrid">PDCA:</span>
            <span>{props?.data?.data?.pdca}</span>
          </div> }
          <div>
            <span className="labelrailgrid">Plan:</span>
            <span>{props?.data?.data?.plan}</span>
          </div>
          <div>
            <span className="labelrailgrid">Do:</span>
            <span>{props?.data?.data?.do}</span>
          </div>
          <div>
            <span className="labelrailgrid">Check:</span>
            <span>{props?.data?.data?.check}</span>
          </div>
          <div>
            <span className="labelrailgrid">Act:</span>
            <span>{props?.data?.data?.act}</span>
          </div>
          <div>
            <span className="labelrailgrid">Related To:</span>
            <span>{props?.data?.data?.moduleLink}</span>
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid grey",
          borderRadius: "5px",
          padding: "5px",
          marginTop: "5px",
        }}
      >
        <div
          style={{ width: "20%", display: "inline-block", fontSize: "larger" }}
        >
          <span className="labelrailgrid">Created By:</span>
          <span>{props?.data?.data?.createdBy}</span>
        </div>
        <div
          style={{ width: "25%", display: "inline-block", fontSize: "larger" }}
        >
          <span className="labelrailgrid">Created Date:</span>
          <span>{props?.data?.data?.createdDate}</span>
        </div>
        <div
          style={{ width: "20%", display: "inline-block", fontSize: "larger" }}
        >
          <span className="labelrailgrid">Modified By:</span>
          <span>{props?.data?.data?.modifiedBy}</span>
        </div>
        <div
          style={{ width: "25%", display: "inline-block", fontSize: "larger" }}
        >
          <span className="labelrailgrid">ModifiedDate date:</span>
          <span>{props?.data?.data?.modifiedDate}</span>
        </div>
      </div>
    </>
  );
};
export default RailViewData;
